import { Order } from "../../../../graphics/tables/operations/sort";
import { ApiDatasource } from "../../adapters/io/datasources/ApiDatasource";
import { unwrap } from "../../adapters/io/network/HttpResponse";
import { formatText } from "../../adapters/io/network/utils";
import { ApiDatasourceSpec } from "../../core/datasource";
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';
import {QuotaChannelStoreAuditTableStructure} from "../indexes/QuotaChannelStoreAuditIndexes";

export const searchQuotaChannelStoreAudit = <T>(
    authState: AuthState,
    search: QuotaChannelStoreAuditTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<QuotaChannelStoreAuditTableStructure.ResponseOf<T>> => {
    const params = new Map();
    const body = {
        fieldSearches : search
    }
    page !== undefined && params.set('page', page);
    limit !== undefined && params.set('limit', limit);
    order !== undefined && params.set('order', order);
    orderBy !== undefined && params.set('orderBy', orderBy);

    return datasource.remote
        .postData<QuotaChannelStoreAuditTableStructure.ResponseOf<T>, QuotaChannelStoreAuditTableStructure.ListOfFormattedSearchValue>(
            uriFormatter(EndpointQuotaChannelStoreAudit.endPoint.concat(EndpointQuotaChannelStoreAudit.searchQuotaChannelStoreAudit), {}),
            body, buildHeader(authState), params)
        .then(unwrap);
};

export const getQuotaChannelStoreAuditColumnInformation = <T>(
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<QuotaChannelStoreAuditTableStructure.ResponseOfColumn<T>> => {
    const params = new Map();

    return datasource.remote
        .getData<QuotaChannelStoreAuditTableStructure.ResponseOfColumn<T>>(
            uriFormatter(EndpointQuotaChannelStoreAudit.endPoint.concat(EndpointQuotaChannelStoreAudit.getQuotaChannelStoreAuditColumnInformation), {}),
            buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointQuotaChannelStoreAudit = {
    endPoint: '/end-point/quota',
    searchQuotaChannelStoreAudit: '/audit-quota-channel-store/search',
    getQuotaChannelStoreAuditColumnInformation: '/audit-quota-channel-store'
};